// Finds floor plans the listing source didn't label. Some listings have their floor plan among the photos
// with no label, so the popup has no Planritning button. A floor plan is a line drawing: mostly white,
// with almost no colour. Measured on 25 labelled floor plans and ~700 photos: plans are >= 53 % near-white
// with < 1 % coloured pixels; the whitest photos are <= 45 % white.
// Only the last few photos are checked (that's where floor plans end up), in a small size.

const CHECK_LAST = 4;
const SAMPLE = 64;
const MIN_WHITE = 0.5;
const MAX_COLOUR = 0.03;

const cache = new Map(); // url -> Promise<boolean>

const smallUrl = (url) => String(url).replace(/_\d+x0\.(jpe?g|png|webp)$/i, '_320x0.$1');

const looksLikeDrawing = (url) => {
    if (cache.has(url)) return cache.get(url);
    const result = new Promise((resolve) => {
        if (typeof document === 'undefined') {
            resolve(false);
            return;
        }
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.decoding = 'async';
        img.onload = () => {
            try {
                const canvas = document.createElement('canvas');
                canvas.width = SAMPLE;
                canvas.height = SAMPLE;
                const context = canvas.getContext('2d', { willReadFrequently: true });
                context.drawImage(img, 0, 0, SAMPLE, SAMPLE);
                const data = context.getImageData(0, 0, SAMPLE, SAMPLE).data;
                let white = 0;
                let colour = 0;
                for (let i = 0; i < data.length; i += 4) {
                    const max = Math.max(data[i], data[i + 1], data[i + 2]);
                    const min = Math.min(data[i], data[i + 1], data[i + 2]);
                    if (min > 232) white += 1;
                    if (max - min > 40) colour += 1;
                }
                const pixels = SAMPLE * SAMPLE;
                resolve(white / pixels >= MIN_WHITE && colour / pixels < MAX_COLOUR);
            } catch (error) {
                // A host without CORS taints the canvas; treat it as a photo.
                resolve(false);
            }
        };
        img.onerror = () => resolve(false);
        img.src = smallUrl(url);
    });
    cache.set(url, result);
    return result;
};

/** The urls among the last few photos that look like floor plans. */
export const detectFloorplans = async (urls) => {
    const candidates = (urls || []).filter(Boolean).slice(1).slice(-CHECK_LAST);
    const checks = await Promise.all(candidates.map((url) => looksLikeDrawing(url)));
    return candidates.filter((url, index) => checks[index]);
};
